import { render } from "./SaleServices.vue?vue&type=template&id=6b520c25&ts=true"
import script from "./SaleServices.vue?vue&type=script&lang=ts"
export * from "./SaleServices.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__